import { render, staticRenderFns } from "./SearchTask.vue?vue&type=template&id=dd978a00&"
import script from "./SearchTask.vue?vue&type=script&lang=js&"
export * from "./SearchTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports